import React from 'react';
import PropTypes from 'prop-types';
import { rd } from '@passionware/monads';
import { myServices } from 'v5/services/services.connected.app';

// COMPONENTS
import { ContactPageLink } from 'v1/components/shared/byModel/Resource/ContactPageLink/ContactPageLink';

// HELPERS
import { renderResourceGroups } from 'v1/helpers/contactHelpers';

// IMPORTS
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import './ResourceMeta.scss';

const ORGANISATION_LABEL = 'Org';

export const ResourceMeta = ({
  size,
  resource = {},
  hideRole,
  hideRepresentation
}) => {
  const {
    role,
    groups = [],
    organisation,
    organisation_id,
    resource_type
  } = resource;

  const readOrganisation = rd.tryGet(
    myServices.resourceService.useItem(
      organisation || hideRepresentation ? null : organisation_id
    )
  );

  function renderRepresentation() {
    if (hideRepresentation) return;
    const representationResource = organisation || readOrganisation;
    if (representationResource) {
      // Get organisation label
      const coreFieldDefinitions = get(
        resource_type,
        'metastructure.fields',
        []
      );
      const organisationDefinition = coreFieldDefinitions.find(
        definition => definition.name === 'organisation_id'
      );
      const label = get(organisationDefinition, 'label', ORGANISATION_LABEL);
      return (
        <div>
          <span className="ResourceMeta-resourceRepresentation">
            {label}
            {': '}
            <ContactPageLink
              contactId={get(representationResource, 'id')}
              target="_blank"
              className="genericLink"
              title={`Represented by ${get(
                representationResource,
                'full_name'
              )}`}
            >
              {get(representationResource, 'full_name')}
            </ContactPageLink>
          </span>
        </div>
      );
    }
    return false;
  }

  function renderRole() {
    if (hideRole) return;
    return (
      <>
        <span>{role}</span>
      </>
    );
  }

  if (size === 'L') {
    return (
      <h3>
        {renderRole()}
        {renderRepresentation()}
      </h3>
    );
  }

  return (
    <span className="ResourceMeta">
      {renderRole()}
      {renderRepresentation()}
    </span>
  );
};

ResourceMeta.propTypes = {
  size: PropTypes.oneOf(['L']),
  resource: PropTypes.object.isRequired,
  hideRole: PropTypes.bool,
  hideRepresentation: PropTypes.bool
};

export default ResourceMeta;
